import React, { useState, useEffect } from 'react';
import styles from './App.module.css';

interface Slip {
  id: number;
  advice: string;
};

function AdviceRandom() {
  const [advice, setAdvice] = useState<string>('');
  const [id, setId] = useState<number>(0);

  useEffect(() => {
    fetch('https://api.adviceslip.com/advice')
      .then(response => response.json())
      .then((data: {slip:Slip}) => {
        setAdvice(data.slip.advice);
        setId(data.slip.id);
      })
      .catch((error: Error) => console.error(error));
  }, []);

  function handleShuffle(){
    const min: number = 1;
    const max: number = 244;
    let randomNumber: number = Math.floor(Math.random() * (max - min + 1) + min);
    fetch(`https://api.adviceslip.com/advice/${randomNumber}`)
      .then(response => response.json())
      .then((data: {slip:Slip}) => {
        setAdvice(data.slip.advice);
        setId(data.slip.id);
      })
      .catch((error: Error) => console.error(error));
  };


  let idS = id.toString().padStart(3, '0');
  
  return (
    <div className={styles.container}>
      <p id="advice-index"className={styles.index}>Advice #{idS}</p>
      <p className={styles.text}>"{advice}"</p>
      <div className={styles.dividerD}></div>
      <div className={styles.dividerM}></div>
      <button className={styles.btn} onClick={handleShuffle}></button>
    </div>
  );
};

export default AdviceRandom;